module.exports = __webpack_public_path__ + "img/Tanks.21fac536.jpg";